import DataSourceModel from '../models/DataSourceModel';
import BaseStore from './BaseStore';

class DataSourceStore extends BaseStore {
  dataOriginStore;
  daqProcessorStore;

  constructor(transportLayer, dataOriginStore, daqProcessorStore) {
    super(DataSourceModel, transportLayer);
    this.dataOriginStore = dataOriginStore;
    this.daqProcessorStore = daqProcessorStore;
  }
}

export default DataSourceStore;



// WEBPACK FOOTER //
// ./src/stores/DataSourceStore.js